// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file crypto/crypto.proto (package lvdr.v2.crypto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crypto/crypto.proto.
 */
export const file_crypto_crypto: GenFile = /*@__PURE__*/
  fileDesc("ChNjcnlwdG8vY3J5cHRvLnByb3RvEg5sdmRyLnYyLmNyeXB0byJGChVDcnlwdG9VbmxvY2tDaGFsbGVuZ2USGgoSd3JhcHBlZF9tYXN0ZXJfa2VrGAEgASgMEhEKCWRldmljZV9pZBgCIAEoCSIqChRDcnlwdG9VbmxvY2tSZXNwb25zZRISCgptYXN0ZXJfa2VrGAEgASgMIjMKFUNyeXB0b1Nlc3Npb25VbmxvY2tlZBIaChJlbmNyeXB0aW9uX2VuYWJsZWQYASABKAgiIwoRQ3J5cHRvU2Vzc2lvbktpbGwSDgoGcmVhc29uGAEgASgJIpQBChBCb290c3RyYXBSZXF1ZXN0EhkKEWRldmljZV9wdWJsaWNfa2V5GAEgASgMEhMKC2RldmljZV9uYW1lGAIgASgJEhoKEndyYXBwZWRfbWFzdGVyX2tlaxgDIAEoDBIYChB3cmFwcGVkX3VzZXJfZGVrGAQgASgMSgQIBRAGUhR3cmFwcGVkX3JlY292ZXJ5X2tleSJ/ChNFbnJvbGxEZXZpY2VSZXF1ZXN0Eh0KFW5ld19kZXZpY2VfcHVibGljX2tleRgBIAEoDBITCgtkZXZpY2VfbmFtZRgCIAEoCRIaChJ3cmFwcGVkX21hc3Rlcl9rZWsYAyABKAwSGAoQYW5jaG9yX2RldmljZV9pZBgEIAEoCSIoChNSZXZva2VEZXZpY2VSZXF1ZXN0EhEKCWRldmljZV9pZBgBIAEoCSLGAQoMUmVrZXlSZXF1ZXN0EjUKC2RldmljZV9rZWtzGAEgAygLMiAubHZkci52Mi5jcnlwdG8uRGV2aWNlV3JhcHBlZEtFSxIYChB3cmFwcGVkX3VzZXJfZGVrGAIgASgMEjkKDXJlc2VhcmNoX2Rla3MYAyADKAsyIi5sdmRyLnYyLmNyeXB0by5SZXNlYXJjaFdyYXBwZWRERUsSEgoKbWFzdGVyX2tlaxgEIAEoDBIWCg5uZXdfbWFzdGVyX2tlaxgFIAEoDCI6ChBEZXZpY2VXcmFwcGVkS0VLEhEKCWRldmljZV9pZBgBIAEoCRITCgt3cmFwcGVkX2tlaxgCIAEoDCI+ChJSZXNlYXJjaFdyYXBwZWRERUsSEwoLcmVzZWFyY2hfaWQYASABKAkSEwoLd3JhcHBlZF9kZWsYAiABKAwigAEKDlJlY292ZXJSZXF1ZXN0EhkKEWRldmljZV9wdWJsaWNfa2V5GAEgASgMEhMKC2RldmljZV9uYW1lGAIgASgJEhoKEndyYXBwZWRfbWFzdGVyX2tlaxgDIAEoDBIOCgZyb3RhdGUYBCABKAgSEgoKbWFzdGVyX2tlaxgFIAEoDCJBChJEZXZpY2VMaXN0UmVzcG9uc2USKwoHZGV2aWNlcxgBIAMoCzIaLmx2ZHIudjIuY3J5cHRvLkRldmljZUluZm8ibwoKRGV2aWNlSW5mbxIRCglkZXZpY2VfaWQYASABKAkSEwoLZGV2aWNlX25hbWUYAiABKAkSEQoJaXNfYW5jaG9yGAMgASgIEhMKC2Vucm9sbGVkX2F0GAQgASgJEhEKCWxhc3Rfc2VlbhgFIAEoCSJQChNSb3RhdGlvblN0YXR1c0V2ZW50Eg8KB3VyZ2VuY3kYASABKAkSFgoOZGF5c19yZW1haW5pbmcYAiABKAUSEAoIZGVhZGxpbmUYAyABKAkiHQobR2V0S2V5Um90YXRpb25TdGF0dXNSZXF1ZXN0IlYKGUtleVJvdGF0aW9uU3RhdHVzUmVzcG9uc2USDwoHdXJnZW5jeRgBIAEoCRIWCg5kYXlzX3JlbWFpbmluZxgCIAEoBRIQCghkZWFkbGluZRgDIAEoCUInWiVnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY3J5cHRvYgZwcm90bzM");

/**
 * Sent by server after JWT auth succeeds, includes the wrapped Master KEK
 * for this device so the client can unwrap and send back the plaintext.
 *
 * @generated from message lvdr.v2.crypto.CryptoUnlockChallenge
 */
export type CryptoUnlockChallenge = Message<"lvdr.v2.crypto.CryptoUnlockChallenge"> & {
  /**
   * @generated from field: bytes wrapped_master_kek = 1;
   */
  wrappedMasterKek: Uint8Array;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;
};

/**
 * Describes the message lvdr.v2.crypto.CryptoUnlockChallenge.
 * Use `create(CryptoUnlockChallengeSchema)` to create a new message.
 */
export const CryptoUnlockChallengeSchema: GenMessage<CryptoUnlockChallenge> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 0);

/**
 * Sent by client with the unwrapped Master KEK so the server can derive DEKs.
 *
 * @generated from message lvdr.v2.crypto.CryptoUnlockResponse
 */
export type CryptoUnlockResponse = Message<"lvdr.v2.crypto.CryptoUnlockResponse"> & {
  /**
   * @generated from field: bytes master_kek = 1;
   */
  masterKek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.CryptoUnlockResponse.
 * Use `create(CryptoUnlockResponseSchema)` to create a new message.
 */
export const CryptoUnlockResponseSchema: GenMessage<CryptoUnlockResponse> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 1);

/**
 * Sent by server when session is unlocked and stores are open.
 *
 * @generated from message lvdr.v2.crypto.CryptoSessionUnlocked
 */
export type CryptoSessionUnlocked = Message<"lvdr.v2.crypto.CryptoSessionUnlocked"> & {
  /**
   * @generated from field: bool encryption_enabled = 1;
   */
  encryptionEnabled: boolean;
};

/**
 * Describes the message lvdr.v2.crypto.CryptoSessionUnlocked.
 * Use `create(CryptoSessionUnlockedSchema)` to create a new message.
 */
export const CryptoSessionUnlockedSchema: GenMessage<CryptoSessionUnlocked> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 2);

/**
 * Sent by server to force client disconnect (device revoked, re-key needed).
 *
 * @generated from message lvdr.v2.crypto.CryptoSessionKill
 */
export type CryptoSessionKill = Message<"lvdr.v2.crypto.CryptoSessionKill"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.crypto.CryptoSessionKill.
 * Use `create(CryptoSessionKillSchema)` to create a new message.
 */
export const CryptoSessionKillSchema: GenMessage<CryptoSessionKill> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 3);

/**
 * POST /api/v1/crypto/bootstrap — first device enrollment
 *
 * @generated from message lvdr.v2.crypto.BootstrapRequest
 */
export type BootstrapRequest = Message<"lvdr.v2.crypto.BootstrapRequest"> & {
  /**
   * @generated from field: bytes device_public_key = 1;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: bytes wrapped_master_kek = 3;
   */
  wrappedMasterKek: Uint8Array;

  /**
   * @generated from field: bytes wrapped_user_dek = 4;
   */
  wrappedUserDek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.BootstrapRequest.
 * Use `create(BootstrapRequestSchema)` to create a new message.
 */
export const BootstrapRequestSchema: GenMessage<BootstrapRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 4);

/**
 * POST /api/v1/crypto/enroll — subsequent device enrollment
 *
 * @generated from message lvdr.v2.crypto.EnrollDeviceRequest
 */
export type EnrollDeviceRequest = Message<"lvdr.v2.crypto.EnrollDeviceRequest"> & {
  /**
   * @generated from field: bytes new_device_public_key = 1;
   */
  newDevicePublicKey: Uint8Array;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: bytes wrapped_master_kek = 3;
   */
  wrappedMasterKek: Uint8Array;

  /**
   * @generated from field: string anchor_device_id = 4;
   */
  anchorDeviceId: string;
};

/**
 * Describes the message lvdr.v2.crypto.EnrollDeviceRequest.
 * Use `create(EnrollDeviceRequestSchema)` to create a new message.
 */
export const EnrollDeviceRequestSchema: GenMessage<EnrollDeviceRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 5);

/**
 * POST /api/v1/crypto/revoke
 *
 * @generated from message lvdr.v2.crypto.RevokeDeviceRequest
 */
export type RevokeDeviceRequest = Message<"lvdr.v2.crypto.RevokeDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message lvdr.v2.crypto.RevokeDeviceRequest.
 * Use `create(RevokeDeviceRequestSchema)` to create a new message.
 */
export const RevokeDeviceRequestSchema: GenMessage<RevokeDeviceRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 6);

/**
 * POST /api/v1/crypto/rekey — rotate the master KEK (AUTH-16). A doc-only
 * mirror of the JSON body: the route takes JSON, not this message. The caller
 * proves the current KEK; the server seals the new KEK to every active device
 * in one transaction, then ends every session of the user. A rekey makes every
 * legacy printed password sheet useless.
 *
 * @generated from message lvdr.v2.crypto.RekeyRequest
 */
export type RekeyRequest = Message<"lvdr.v2.crypto.RekeyRequest"> & {
  /**
   * Refused when non-empty since AUTH-16; the server seals the new KEK to every
   * device.
   *
   * @generated from field: repeated lvdr.v2.crypto.DeviceWrappedKEK device_keks = 1;
   */
  deviceKeks: DeviceWrappedKEK[];

  /**
   * The user DEK wrapped under new_master_kek. Must open to the current DEK.
   *
   * @generated from field: bytes wrapped_user_dek = 2;
   */
  wrappedUserDek: Uint8Array;

  /**
   * JSON name project_deks; refused when non-empty.
   *
   * @generated from field: repeated lvdr.v2.crypto.ResearchWrappedDEK research_deks = 3;
   */
  researchDeks: ResearchWrappedDEK[];

  /**
   * The current master KEK: the proof. Missing or wrong is a 403
   * MASTER_KEK_PROOF_FAILED and mails the owner.
   *
   * @generated from field: bytes master_kek = 4;
   */
  masterKek: Uint8Array;

  /**
   * The new master KEK (32 bytes, different from master_kek) that every active
   * device receives.
   *
   * @generated from field: bytes new_master_kek = 5;
   */
  newMasterKek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.RekeyRequest.
 * Use `create(RekeyRequestSchema)` to create a new message.
 */
export const RekeyRequestSchema: GenMessage<RekeyRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 7);

/**
 * @generated from message lvdr.v2.crypto.DeviceWrappedKEK
 */
export type DeviceWrappedKEK = Message<"lvdr.v2.crypto.DeviceWrappedKEK"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: bytes wrapped_kek = 2;
   */
  wrappedKek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.DeviceWrappedKEK.
 * Use `create(DeviceWrappedKEKSchema)` to create a new message.
 */
export const DeviceWrappedKEKSchema: GenMessage<DeviceWrappedKEK> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 8);

/**
 * @generated from message lvdr.v2.crypto.ResearchWrappedDEK
 */
export type ResearchWrappedDEK = Message<"lvdr.v2.crypto.ResearchWrappedDEK"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: bytes wrapped_dek = 2;
   */
  wrappedDek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.ResearchWrappedDEK.
 * Use `create(ResearchWrappedDEKSchema)` to create a new message.
 */
export const ResearchWrappedDEKSchema: GenMessage<ResearchWrappedDEK> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 9);

/**
 * POST /api/v1/crypto/recover
 *
 * @generated from message lvdr.v2.crypto.RecoverRequest
 */
export type RecoverRequest = Message<"lvdr.v2.crypto.RecoverRequest"> & {
  /**
   * @generated from field: bytes device_public_key = 1;
   */
  devicePublicKey: Uint8Array;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: bytes wrapped_master_kek = 3;
   */
  wrappedMasterKek: Uint8Array;

  /**
   * rotate revokes every other device; it changes no key material.
   *
   * @generated from field: bool rotate = 4;
   */
  rotate: boolean;

  /**
   * master_kek is the plaintext master KEK, proof of possession: the server
   * opens wrapped_user_dek with it and zeroes it (AUTH-15).
   *
   * @generated from field: bytes master_kek = 5;
   */
  masterKek: Uint8Array;
};

/**
 * Describes the message lvdr.v2.crypto.RecoverRequest.
 * Use `create(RecoverRequestSchema)` to create a new message.
 */
export const RecoverRequestSchema: GenMessage<RecoverRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 10);

/**
 * GET /api/v1/crypto/devices
 *
 * @generated from message lvdr.v2.crypto.DeviceListResponse
 */
export type DeviceListResponse = Message<"lvdr.v2.crypto.DeviceListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.crypto.DeviceInfo devices = 1;
   */
  devices: DeviceInfo[];
};

/**
 * Describes the message lvdr.v2.crypto.DeviceListResponse.
 * Use `create(DeviceListResponseSchema)` to create a new message.
 */
export const DeviceListResponseSchema: GenMessage<DeviceListResponse> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 11);

/**
 * @generated from message lvdr.v2.crypto.DeviceInfo
 */
export type DeviceInfo = Message<"lvdr.v2.crypto.DeviceInfo"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: bool is_anchor = 3;
   */
  isAnchor: boolean;

  /**
   * @generated from field: string enrolled_at = 4;
   */
  enrolledAt: string;

  /**
   * @generated from field: string last_seen = 5;
   */
  lastSeen: string;
};

/**
 * Describes the message lvdr.v2.crypto.DeviceInfo.
 * Use `create(DeviceInfoSchema)` to create a new message.
 */
export const DeviceInfoSchema: GenMessage<DeviceInfo> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 12);

/**
 * RotationStatusEvent pushes rotation status changes to the frontend via WebSocket.
 *
 * @generated from message lvdr.v2.crypto.RotationStatusEvent
 */
export type RotationStatusEvent = Message<"lvdr.v2.crypto.RotationStatusEvent"> & {
  /**
   * "info", "warning", "urgent", "overdue", "none"
   *
   * @generated from field: string urgency = 1;
   */
  urgency: string;

  /**
   * negative if overdue
   *
   * @generated from field: int32 days_remaining = 2;
   */
  daysRemaining: number;

  /**
   * ISO 8601 date string
   *
   * @generated from field: string deadline = 3;
   */
  deadline: string;
};

/**
 * Describes the message lvdr.v2.crypto.RotationStatusEvent.
 * Use `create(RotationStatusEventSchema)` to create a new message.
 */
export const RotationStatusEventSchema: GenMessage<RotationStatusEvent> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 13);

/**
 * GetKeyRotationStatusRequest fetches the caller's current rotation status.
 * User identity is taken from the authenticated WS connection, not the request.
 * Response shape mirrors RotationStatusEvent for consistency with push updates.
 *
 * @generated from message lvdr.v2.crypto.GetKeyRotationStatusRequest
 */
export type GetKeyRotationStatusRequest = Message<"lvdr.v2.crypto.GetKeyRotationStatusRequest"> & {
};

/**
 * Describes the message lvdr.v2.crypto.GetKeyRotationStatusRequest.
 * Use `create(GetKeyRotationStatusRequestSchema)` to create a new message.
 */
export const GetKeyRotationStatusRequestSchema: GenMessage<GetKeyRotationStatusRequest> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 14);

/**
 * @generated from message lvdr.v2.crypto.KeyRotationStatusResponse
 */
export type KeyRotationStatusResponse = Message<"lvdr.v2.crypto.KeyRotationStatusResponse"> & {
  /**
   * @generated from field: string urgency = 1;
   */
  urgency: string;

  /**
   * @generated from field: int32 days_remaining = 2;
   */
  daysRemaining: number;

  /**
   * empty when urgency == "none"
   *
   * @generated from field: string deadline = 3;
   */
  deadline: string;
};

/**
 * Describes the message lvdr.v2.crypto.KeyRotationStatusResponse.
 * Use `create(KeyRotationStatusResponseSchema)` to create a new message.
 */
export const KeyRotationStatusResponseSchema: GenMessage<KeyRotationStatusResponse> = /*@__PURE__*/
  messageDesc(file_crypto_crypto, 15);

